module.exports = __webpack_public_path__ + "img/product_22.2322190.svg";